function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "submitData",
    // Execution flows:
    // Button -> Button.onClick() -> Utils.http.execute() -- doesn't save autofill values
    // Button -> Button.onClick() -> form.submit() -- doesn't execute Form.onSubmit(), so cannot call Utils.http.execute() there
    // Submit -> Form.onSubmit() -> Utils.http.execute() -- save autofill values and auto-submit when ENTER is pressed
    value: function submitData(form, component) {
      var overrideUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // Analogous to Rails' form_with's `local: true`
      if (form.dataset.local) {
        // Prevent onUnload dirty prompt.
        Utils.http.clearDirtyState();
        form.submit();
      } else {
        var url = overrideUrl ? overrideUrl : form.getAttribute("action");
        var formData = new FormData(form);
        var method = form.getAttribute("method");

        if (method.toUpperCase() === "GET") {
          var data = {
            url: Utils.url.appendParams(url, formData)
          };
          Utils.http.notifyFormSubmitted();
          Utils.http.load(data, component);
        } else {
          var _data = {
            url: url,
            formData: formData
          };
          Utils.http.execute(_data, method, component, function (response) {
            Utils.http.notifyFormSubmitted();
            GLib.action.handleResponse(response, component);
          });
        }
      }
    }
  }]);

  return _default;
}();

export { _default as default };